import { Label } from "@/components/ui/label";
import { VenueList } from "./location/VenueList";
import { Textarea } from "@/components/ui/textarea";
import { SuburbCombobox } from "./location/SuburbCombobox";
interface LocationSelectorProps {
  locationType: 'specific' | 'flexible';
  location: string;
  preferredVenues: string[];
  locationNote: string;
  onLocationTypeChange: (type: 'specific' | 'flexible') => void;
  onLocationChange: (location: string) => void;
  onPreferredVenuesChange: (venues: string[]) => void;
  onLocationNoteChange: (note: string) => void;
  error?: string;
}
export const LocationSelector = ({
  preferredVenues,
  locationNote,
  onPreferredVenuesChange,
  onLocationNoteChange,
  error
}: LocationSelectorProps) => {
  const handleAddSuburb = (suburb: string) => {
    if (suburb && !preferredVenues.includes(suburb)) {
      const updatedVenues = [...preferredVenues, suburb];
      onPreferredVenuesChange(updatedVenues);
    }
  };
  const handleRemoveVenue = (venueToRemove: string) => {
    const updatedVenues = preferredVenues.filter(venue => venue !== venueToRemove);
    onPreferredVenuesChange(updatedVenues);
  };
  return <div className="space-y-4">
      <div className="space-y-4">
        <div>
          <Label className="mb-2 block">Suburbs</Label>
          <SuburbCombobox onSuburbSelect={handleAddSuburb} selectedSuburbs={preferredVenues} />
        </div>
        
        {preferredVenues.length > 0 && <VenueList venues={preferredVenues} onRemoveVenue={handleRemoveVenue} label="Selected Suburbs" />}

        <div className="space-y-2 pt-2">
          <Label>What did you have in mind?</Label>
          <Textarea placeholder="Add notes about the location (e.g., Rooftop bar, Great margaritas)" value={locationNote} onChange={e => onLocationNoteChange(e.target.value)} className={error ? "border-destructive" : ""} />
          {error && <p className="text-sm text-destructive mt-1">{error}</p>}
        </div>
      </div>
    </div>;
};